 const isAssetValid =asset=> {
     return asset && asset.stats;
 }
 
 const isUser =vehicle=> {
     return vehicle.type == 'user';
 }
 
 const isVehicle =vehicle=> {
     return !isUser(vehicle);
 }

export default [
    {
        key: 'no_soc', name: 'No SoC', iconType: 'class',clr:"#f05f5f", icon: 'lnr lnr-eye',type:"soc", override: vehicle => {
            return isAssetValid(vehicle) && isVehicle(vehicle);
        }
    },
    {
        key: 'SOC_NEG', name: '<0%', iconType: 'class',clr:"#f05f5f", icon: 'lnr lnr-eye',type:"soc", override: vehicle => {
            return isAssetValid(vehicle) && isVehicle(vehicle);
        }
    },
    {
        key: 'SOC_0', name: '0%', iconType: 'class',clr:"#f05f5f", icon: 'lnr lnr-eye',type:"soc", override: vehicle => {
            return isAssetValid(vehicle) && isVehicle(vehicle);
        }
    },
    {
        key: 'soc_1_25', name: '1-25%', iconType: 'class',clr:"#f05f5f", icon: 'lnr lnr-eye',type:"soc", override: vehicle => {
            return isAssetValid(vehicle) && isVehicle(vehicle);
        }
    },
    {
        key: 'soc_25_50', name: '25-50%', iconType: 'class',clr:"#ffc478", icon: 'lnr lnr-eye',type:"soc", override: vehicle => {
            return isAssetValid(vehicle) && isVehicle(vehicle);
        }
    },
    {
        key: 'soc_50_75', name: '50-75%', iconType: 'class',clr:"#5eaaa8", icon: 'lnr lnr-eye',type:"soc", override: vehicle => {
            return isAssetValid(vehicle) && isVehicle(vehicle);
        }
    },
    {
        key: 'soc_75_100', name: '>75%', iconType: 'class',clr:"#5bcc5b", icon: 'lnr lnr-eye',type:"soc", override: vehicle => {
            return isAssetValid(vehicle) && isVehicle(vehicle);
        }
    },
    {
        key: 'curentlycharging', name: 'CC', iconType: 'class',clr:"#5bcc5b", icon: 'lnr lnr-eye',type:"cc", override: vehicle => {
            return isAssetValid(vehicle) && isVehicle(vehicle);
        }
    },

    {
        key: 'no_temp', name: 'No Temp', iconType: 'class',clr:"#f05f5f", icon: 'lnr lnr-eye',type:"temp", override: vehicle => {
            return isAssetValid(vehicle) && isVehicle(vehicle);
        }
    },
    {
        key: 'BTT_NEG', name: '<0°C', iconType: 'class',clr:"#f05f5f", icon: 'lnr lnr-eye',type:"temp", override: vehicle => {
            return isAssetValid(vehicle) && isVehicle(vehicle);
        }
    },
    {
        key: 'BTT_0', name: '0°C', iconType: 'class',clr:"#f05f5f", icon: 'lnr lnr-eye',type:"temp", override: vehicle => {
            return isAssetValid(vehicle) && isVehicle(vehicle);
        }
    },
    {
        key: 'btt_1_15', name: '1-15°C', iconType: 'class',clr:"#5eaaa8", icon: 'lnr lnr-eye',type:"temp", override: vehicle => {
            return isAssetValid(vehicle) && isVehicle(vehicle);
        }
    },
    {
        key: 'btt_15_30', name: '15-30°C', iconType: 'class',clr:"#5bcc5b", icon: 'lnr lnr-eye',type:"temp", override: vehicle => {
            return isAssetValid(vehicle) && isVehicle(vehicle);
        }
    },
    {
        key: 'btt_30_45', name: '30-45°C', iconType: 'class',clr:"#ffc478", icon: 'lnr lnr-eye',type:"temp", override: vehicle => {
            return isAssetValid(vehicle) && isVehicle(vehicle);
        }
    },
    {
        key: 'btt_a_45', name: '>45°C', iconType: 'class',clr:"#f05f5f", icon: 'lnr lnr-eye',type:"temp", override: vehicle => {
            return isAssetValid(vehicle) && isVehicle(vehicle);
        }
    },
    {
        key: 'CLT_NA', name: 'No Temp', iconType: 'class',clr:"#f05f5f", icon: 'lnr lnr-eye',type:"celltemp", override: vehicle => {
            return isAssetValid(vehicle) && isVehicle(vehicle);
        }
    },
    {
        key: 'CLT_NEG', name: '<0°C', iconType: 'class',clr:"#f05f5f", icon: 'lnr lnr-eye',type:"celltemp", override: vehicle => {
            return isAssetValid(vehicle) && isVehicle(vehicle);
        }
    },
    {
        key: 'CLT_0', name: '0°C', iconType: 'class',clr:"#f05f5f", icon: 'lnr lnr-eye',type:"celltemp", override: vehicle => {
            return isAssetValid(vehicle) && isVehicle(vehicle);
        }
    },
    {
        key: 'CLT_1_15', name: '1-15°C', iconType: 'class',clr:"#5eaaa8", icon: 'lnr lnr-eye',type:"celltemp", override: vehicle => {
            return isAssetValid(vehicle) && isVehicle(vehicle);
        }
    },
    {
        key: 'CLT_15_30', name: '15-30°C', iconType: 'class',clr:"#5bcc5b", icon: 'lnr lnr-eye',type:"celltemp", override: vehicle => {
            return isAssetValid(vehicle) && isVehicle(vehicle);
        }
    },
    {
        key: 'CLT_30_45', name: '30-45°C', iconType: 'class',clr:"#ffc478", icon: 'lnr lnr-eye',type:"celltemp", override: vehicle => {
            return isAssetValid(vehicle) && isVehicle(vehicle);
        }
    },
    {
        key: 'CLT_A_45', name: '>45°C', iconType: 'class',clr:"#f05f5f", icon: 'lnr lnr-eye',type:"celltemp", override: vehicle => {
            return isAssetValid(vehicle) && isVehicle(vehicle);
        }
    },
    // {
    //     key: 'no_soc', name: 'No SOC', iconType: 'class',clr:"#f05f5f", icon: 'lnr lnr-eye',type:"soc", override: vehicle => {
    //         return isAssetValid(vehicle) && isVehicle(vehicle);
    //     }
    // },
    // {
    //     key: 'no_temp', name: 'No Temp', iconType: 'class',clr:"#f05f5f", icon: 'lnr lnr-eye',type:"temp", override: vehicle => {
    //         return isAssetValid(vehicle) && isVehicle(vehicle);
    //     }
    // },
    // {
    //     key: 'SOC_0', name: '0%', iconType: 'class',clr:"#f05f5f", icon: 'lnr lnr-eye',type:"soc", override: vehicle => {
    //         return isAssetValid(vehicle) && isVehicle(vehicle);
    //     }
    // },
    // {
    //     key: 'SOC_NEG', name: '<0%', iconType: 'class',clr:"#f05f5f", icon: 'lnr lnr-eye',type:"soc", override: vehicle => {
    //         return isAssetValid(vehicle) && isVehicle(vehicle);
    //     }
    // },
    // {
    //     key: 'BTT_0', name: '0°C', iconType: 'class',clr:"#f05f5f", icon: 'lnr lnr-eye',type:"temp", override: vehicle => {
    //         return isAssetValid(vehicle) && isVehicle(vehicle);
    //     }
    // },
    // {
    //     key: 'BTT_NEG', name: '<0°C', iconType: 'class',clr:"#f05f5f", icon: 'lnr lnr-eye',type:"temp", override: vehicle => {
    //         return isAssetValid(vehicle) && isVehicle(vehicle);
    //     }
    // },
    {
        key: 'lock', name: 'Lock', iconType: 'class',clr:"#f05f5f", icon: 'lnr lnr-eye',type:"lock", override: vehicle => {
            return isAssetValid(vehicle) && isVehicle(vehicle);
        }
    },
    {
        key: 'unlock', name: 'Unlock', iconType: 'class',clr:"#f05f5f", icon: 'lnr lnr-eye',type:"unlock", override: vehicle => {
            return isAssetValid(vehicle) && isVehicle(vehicle);
        }
    },
];